// Package imports:
import React, { useEffect, useMemo, useState } from 'react';
// Component imports:
import HeadSection from '../../ui-elements/HeadSection/HeadSection';
import DomesticPepSearch from './DomesticSearch'
import ForeignPepSearch, { IForeignSearchParams } from './ForeignSearch';
import KYCNavBar from '../Company/KYCNavBar/KYCNavBar';
// Type imports:
import { Subscription } from '../../types/KeldanTypes';
import ForeignSearchCompany from './ForeignSearchCompany';
import PepWatch from './PepWatch';

interface IProps {
    isAuthenticated: boolean,
    subscriptions: Subscription[]
}

export interface IPepArray {
    name: string,
    connection: string,
    status: string,
    source: string | JSX.Element | null,
    endDate?: string | null,
}

export interface IPepData {
    connected: boolean,
    name: string | undefined,
    ssn: string | undefined,
    entries: IPepArray[],
}

export interface IPepResults extends IPepData {
    event: {
        id: number,
        date: string,
    }
}
export function formatCategories(strings?: string[]): JSX.Element {
    // Return empty fragment if no strings provided
    if (strings === undefined) return <></>;

    // Create an array to hold each formatted category element
    const elements: JSX.Element[] = [];

    // Process each string and create a separate line for each category
    strings.forEach((str, index) => {
        // Split the string into prefix and suffix parts
        const [prefix, suffix] = str.split(" - ");

        // Add a line break between categories (but not before the first one)
        if (index !== 0) {
            elements.push(<br key={`br-${index}`} />);
        }

        // Create the formatted category line with bold prefix
        elements.push(
            <span key={`category-${index}`}>
                <strong>{prefix}</strong>
                {suffix && <span>: {suffix}</span>}
            </span>
        );
    });

    // Wrap all elements in a container span
    // Note: The parent container should have display: flex and flex-direction: column
    // for proper vertical alignment
    return <span>{elements}</span>;
}

const PEPSearchPage: React.FC<IProps> = ({
    isAuthenticated,
    subscriptions
}) => {
    const [searchParams, setSearchParams] = useState<IForeignSearchParams>({
        firstName: undefined,
        middleName: undefined,
        lastName: undefined,
        dob: undefined
    });

    // State to track the current hash and trigger re-renders when it changes
    const [hash, setHash] = useState<string>(window.location.hash.replace('#', ''));

    // Listen for hash changes in the URL and update state accordingly
    // This ensures the component re-renders when users navigate via browser back/forward
    // or when the hash is changed programmatically
    useEffect(() => {
        const handleHashChange = () => {
            const newHash = window.location.hash.replace('#', '');
            setHash(newHash);
        };

        // Listen for hashchange events on the window
        window.addEventListener('hashchange', handleHashChange);

        // Clean up the event listener when component unmounts
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const ROUTER = useMemo(() => {
        //check the url hash to see which tab to show
        switch (hash) {
            case 'Althjodlegt-Einstaklingar':
                return <ForeignPepSearch
                    isAuthenticated={isAuthenticated}
                    subscriptions={subscriptions}
                    searchParams={searchParams}
                />;
            case 'Althjodlegt-Logadilar':
                return <ForeignSearchCompany
                    isAuthenticated={isAuthenticated}
                    subscriptions={subscriptions}
                />;
            case 'Pep-vaktin':
                return <PepWatch
                    isAuthenticated={isAuthenticated}
                    subscriptions={subscriptions}
                />;
            case 'Island':
            default:
                return <DomesticPepSearch
                    isAuthenticated={isAuthenticated}
                    subscriptions={subscriptions}
                    setParamsForForeignSearch={setSearchParams}
                />;
        }
    }, [hash, isAuthenticated, searchParams, subscriptions]);

    const TITLE = useMemo(() => {
        switch (hash) {
            case 'Althjodlegt-Einstaklingar':
                return "Alþjóðlegir válistar";
            case 'Althjodlegt-Logadilar':
                return "Alþjóðlegir válistar - lögaðilar";
            case 'Pep-vaktin':
                return "PEP vaktin";
            case 'Island':
            default:
                return "Íslenskur PEP listi";
        }
    }, [hash]);

    // scroll to top when hash changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [hash]);

    return (
        <div className="KCL_PEPSearchPage">
            <KYCNavBar />
            <div className='shell'>
                <HeadSection
                    title={TITLE}
                    showRecentReports={isAuthenticated}
                />
            </div>
            {ROUTER}
            {/* <Tabs
                tabsSize="lg"
                saveTabToUrl
                shellHead
                tabs={[{
                    id: "Island",
                    label: "Íslenskur PEP listi",
                    component: <DomesticPepSearch
                        isAuthenticated={isAuthenticated}
                        subscriptions={subscriptions}
                        setParamsForForeignSearch={setSearchParams}
                    />
                }, {
                    id: "Althjodlegt-Einstaklingar",
                    label:"Alþjóðlegir válistar",
                    component: <ForeignPepSearch
                        isAuthenticated={isAuthenticated}
                        subscriptions={subscriptions}
                        searchParams={searchParams}
                    />
                }, {
                    id: "Althjodlegt-Logadilar",
                    label:"Alþjóðlegir válistar - lögaðilar",
                    component: <ForeignSearchCompany
                        isAuthenticated={isAuthenticated}
                        subscriptions={subscriptions}
                    />
                }, {
                    id: "Pep-vaktin",
                    label:"PEP vaktin",
                    component: <PepWatch
                        isAuthenticated={isAuthenticated}
                        subscriptions={subscriptions}
                    />
                }]}
            /> */}
        </div>
    )
}

export default PEPSearchPage;